import { createFileRoute } from '@tanstack/react-router';

import { FullMainHeight, UploadYieldMapForm } from '@ui';

export const Route = createFileRoute('/_app/transfer-yield-map')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <FullMainHeight>
      <UploadYieldMapForm />
    </FullMainHeight>
  );
}
